const addSocialLinks = () => {
  const secondaryNav = document.querySelector(".gh-footer-nav .gh-secondary-nav");
  const linksToMove = ["discord", "discuss"]

  linksToMove.forEach((name) => {
    const link = secondaryNav.querySelector(`.gh-secondary-nav-link[href*='${name}']`)
    const socialLinks = document.querySelectorAll(`.gh-social-icon-link.${name}-link`)

    if (link) {
      socialLinks.forEach((socialLink) => {
        socialLink.style.display = ""
        socialLink.setAttribute("href", link.href)
      })
      link.remove()
    }
  })
};

export { addSocialLinks };
